import { render, staticRenderFns } from "./details.vue?vue&type=template&id=941efe2e&scoped=true"
import script from "./details.vue?vue&type=script&lang=ts"
export * from "./details.vue?vue&type=script&lang=ts"
import style0 from "./details.vue?vue&type=style&index=0&id=941efe2e&prod&lang=css"
import style1 from "./details.vue?vue&type=style&index=1&id=941efe2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941efe2e",
  null
  
)

export default component.exports